import * as React from 'react';
import { isMobile } from 'react-device-detect';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import { validateEmail } from '../../../../constants/validation';
import { IInputTextArea } from '../../../../interfaces/KPInputTextArea/KPInputTextAreaInterfaces';

class KPInputTextArea extends React.PureComponent<IInputTextArea, any> {
    sspInputTextAreaRef: any;

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            submitted: false,
            mailRegex: true,
            hide: true,
            changeDetect: "",
            valueState: "",
            defaultValue: ""
        };
        this.handleClick = this.handleClick.bind(this);
        this.hideSwitch = this.hideSwitch.bind(this);
        this.handlePasswordKeyDown = this.handlePasswordKeyDown.bind(this);
        this.sspInputTextAreaRef = React.createRef();
    }

    handlePasswordKeyDown(e: any) {
        if (e.key === 'Enter') {
            this.handleClick(e);
        }
    }

    hideSwitch = ev => {
        this.setState({ hide: !this.state.hide })
    }

    handleClick(e: any) {
        const { email } = this.state;
        if (validateEmail.test(email)) {
            this.setState({ mailRegex: true });
            e.preventDefault();
            this.setState({ submitted: true });
        } else {
            this.setState({ mailRegex: false });
        }
    }

    public render() {
        const { hide } = this.state;
        let item =
            <>
                <div className="ssp-inputtextarea-input-element-container">
                    <input
                        ref={this.sspInputTextAreaRef}
                        id={this.props.id}
                        name={this.props.name}
                        form={this.props.form}
                        type={this.props.type === "password" ? (hide ? 'password' : 'input') : ((this.props.type ? this.props.type : 'input'))}
                        required={this.props.required}
                        readOnly={this.props.readOnly}
                        disabled={this.props.disabled}
                        placeholder={(this.props.placeholder && this.props.placeholder !== "") ? this.props.placeholder : this.props.label}
                        value={this.props.value}
                        className={"ssp-inputtextarea-input-element " + (this.props.successTick && this.props.type !== "password" ? " ssp-inputtextarea-success-icon " : "") + (this.props.type === "password" ? "ssp-inputtextarea-input-element-password-mode" : "")}
                        autoComplete="off"
                        autoFocus={this.props.autoFocus}
                        minLength={this.props.minLength}
                        maxLength={this.props.maxLength}
                        onChange={(e) => this.props.handleChange(e)}
                        onFocus={(e) => (this.props.onFocus ? this.props.onFocus(e) : null)}
                        onBlur={(e) => (this.props.onBlur ? this.props.onBlur(e) : null)}
                    />
                    {this.props.type === "password" &&
                        <>
                            <div className="ssp-inputtextarea-hideswitch" >
                                <div className={"ssp-inputtextarea-hideswitch-eye-icon ssp-inputtextarea-hideswitch-eye-" + (hide ? 'visible' : 'invisible')} title={(hide ? 'Show password' : 'Hide password')} onClick={this.hideSwitch}></div>
                            </div>
                        </>
                    }
                </div>
            </>
        if (this.props.type.toLowerCase() === "textarea") {
            item =
                <>
                    <div className="ssp-inputtextarea-textarea-element-container">
                        <textarea
                            ref={this.sspInputTextAreaRef}
                            id={this.props.id}
                            name={this.props.name}
                            form={this.props.form}
                            required={this.props.required}
                            readOnly={this.props.readOnly}
                            disabled={this.props.disabled}
                            placeholder={this.props.label}
                            value={this.props.value}
                            className="ssp-inputtextarea-textarea-element"
                            autoComplete="off"
                            autoFocus={this.props.autoFocus}
                            minLength={this.props.minLength}
                            maxLength={this.props.maxLength}
                            onChange={(e) => this.props.handleChange(e)}
                            onFocus={(e) => (this.props.onFocus ? this.props.onFocus(e) : null)}
                            onBlur={(e) => (this.props.onBlur ? this.props.onBlur(e) : null)}
                        />
                    </div>
                </>
        }
        else if (this.props.type.toLowerCase() === "currencyinput") {
            item =
                <>
                    <div className="ssp-inputtextarea-input-element-container">
                        <div className={"nopa"} id="currencyInput">
                        <NumberFormat
                            className="replacement-input"
                            id={this.props.id}
                            name={this.props.name}
                            placeholder={this.props.currencySymbol}
                            thousandSeparator={true}
                            thousandsGroupStyle="thousand"
                            prefix={this.props.currencySymbol}
                            value={this.props.value}
                            disabled={this.props.disabled}
                            readOnly={this.props.readOnly}
                            required={this.props.required}
                            form={this.props.form}
                            ref={this.sspInputTextAreaRef}
                            onChange={(e) => this.props.handleChange(e)}
                            onFocus={(e) => (this.props.onFocus ? this.props.onFocus(e) : null)}
                            onBlur={(e) => (this.props.onBlur ? this.props.onBlur(e) : null)}
                        />
                        </div>
                    </div>
                </>
        }
        return (
            <>
                <div className={'ssp-inputtextarea-container' + ((this.props.notice !== false) ? ' ssp-inputtextarea-container-notice-' + this.props.noticeType + '' : '') + " " + ((this.props.disabled && (this.props.value !== "" || this.props.defaultValue) ? " ssp-inputtextarea-container-disabled ssp-inputtextarea-container-disabled-with-label" : "") || (this.props.disabled ? " ssp-inputtextarea-container-disabled ssp-inputtextarea-container-disabled-without-label" : "")) + " " + (this.props.type === "textarea" ? "ssp-inputtextarea-container-textarea-parent" : "") + " " + (this.props.className)}>
                    <div className="row noma ssp-inputtextarea-row">
                        <div className="col nopa ssp-inputtextarea-col-label">
                            <label className={'ssp-form-label ssp-opacity-0' + ((this.props.value != "" || this.props.alwaysShowLabel) ? " ssp-opacity-1" : " ssp-opacity-0")}>
                                <>
                                    {this.props.label && this.props.labelAfterSelection &&
                                        <>
                                            {this.props.labelAfterSelection}
                                        </>
                                    }
                                    {!this.props.label && this.props.labelAfterSelection &&
                                        <>
                                            {this.props.labelAfterSelection}
                                        </>
                                    }
                                    {this.props.label && !this.props.labelAfterSelection &&
                                        <>
                                            {this.props.label}
                                        </>
                                    }
                                </>
                            </label>
                        </div>
                        <div className="col nopa ssp-inputtextarea-col-input">
                            {item}
                            {this.props.noticeMessage !== "" &&
                                <div className="ssp-inputtextarea-notice-area">
                                    <span>{this.props.noticeMessage ? this.props.noticeMessage : ""}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.firebase.auth,
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(KPInputTextArea)